<section class="card">
  <div class="card-body">
    <h2 class="section-heading text-uppercase text-muted small fw-semibold mb-2">Authentication</h2>
    <div class="d-flex flex-wrap gap-2">
      <button class="btn btn-primary flex-fill" [disabled]="signingIn" (click)="signIn()">
        Sign in
      </button>
      <button class="btn btn-outline-primary flex-fill" (click)="signOut()">
        Sign out
      </button>
    </div>
    <p class="status-text text-muted small mt-2 mb-0" [class]="statusClass" role="status" aria-live="polite">
      {{ status }}
    </p>
  </div>
</section>
